// charity-donation-script.js
// GolfRoots Charity Donation Calculator
// Companion script loaded as a Shopify asset.
// All core logic lives inline in the .liquid template;
// this file is the external-asset version for cache efficiency.

let donationClubs = [];

function loadData(data) {
  const typeSelect  = document.getElementById('club-type');
  const brandSelect = document.getElementById('brand');
  const modelSelect = document.getElementById('model');
  const form        = document.getElementById('donate-form');
  const resultEl    = document.getElementById('donation-result');

  if (!typeSelect || !form) return; // guard if inline already ran

  // Populate types
  typeSelect.innerHTML = '<option value="">Select club type</option>';
  const types = [...new Set(data.map(i => i.Type))].filter(Boolean).sort();
  types.forEach(t => typeSelect.appendChild(new Option(t, t)));

  typeSelect.addEventListener('change', function () {
    resultEl.style.display = 'none';
    resetSteps();

    const selectedType = this.value;
    const brands = [...new Set(data.filter(i => i.Type === selectedType).map(i => i.Brand))].sort();
    brandSelect.innerHTML = '<option value="">Select brand</option>';
    brands.forEach(b => brandSelect.appendChild(new Option(b, b)));
    modelSelect.innerHTML = '<option value="">Select model</option>';

    const ironOpts = document.getElementById('iron-set-options');
    const ironSel  = document.getElementById('iron-set-include');
    if (selectedType === 'Iron Set') {
      ironOpts.style.display = 'flex';
      ironSel.required = true;
    } else {
      ironOpts.style.display = 'none';
      ironSel.required = false;
      ironSel.value = '';
    }
    document.getElementById('missing-clubs').checked = false;
  });

  brandSelect.addEventListener('change', function () {
    resultEl.style.display = 'none';
    resetSteps();
    const models = [...new Set(
      data.filter(i => i.Type === typeSelect.value && i.Brand === this.value).map(i => i.Model)
    )].sort();
    modelSelect.innerHTML = '<option value="">Select model</option>';
    models.forEach(m => modelSelect.appendChild(new Option(m, m)));
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const club = data.find(i =>
      i.Type  === typeSelect.value &&
      i.Brand === brandSelect.value &&
      i.Model === modelSelect.value
    );
    if (!club) return;

    const condition = document.querySelector('input[name="condition"]:checked').value;
    let value = club.Price;
    const condMap = { new: 1.10, 'above-average': 1.0, average: 0.90, poor: 0.80 };
    value *= condMap[condition] || 1;

    if (typeSelect.value === 'Iron Set') {
      const ironOpt = document.getElementById('iron-set-include').value;
      const missing = document.getElementById('missing-clubs').checked;
      const ironMult = {
        '3-9':0.875,'3-PW':1,'3-AW':1.1,'3-SW':1.2,'3-LW':1.2,
        '4-9':0.75,'4-PW':0.875,'4-AW':1,'4-SW':1.1,'4-LW':1.2,
        '5-9':0.50,'5-PW':0.75,'5-AW':0.875,'5-SW':1,'5-LW':1.1,
        '6-PW':0.50,'6-AW':0.75,'6-SW':0.875,'6-LW':1
      };
      if (ironMult[ironOpt]) value *= ironMult[ironOpt];
      if (missing) value *= 0.85;
    }

    const ironSetInclude = document.getElementById('iron-set-include');
    const ironLabel = ironSetInclude.value ? ` (${ironSetInclude.value})` : '';

    updateStepProgress(2);
    resultEl.style.display = 'block';
    resultEl.innerHTML = `
      <div class="result-club-name">${club.Brand} ${club.Model}</div>
      <p class="result-club-type">${club.Type}${ironLabel}</p>
      <div class="donation-amount-display">
        <span class="donation-amount-display__label">Estimated Donation Value</span>
        <div class="donation-amount-display__value">$${value.toFixed(2)}</div>
        <p class="donation-amount-display__note">Based on condition &amp; club configuration · 100% goes to charity</p>
      </div>
      <div class="result-action-row">
        <button class="btn-add-donation"
          onclick="addToList('${club.Brand}','${club.Model}','${club.Type}',${value},'${ironSetInclude.value}',${document.getElementById('missing-clubs').checked})">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          Add to Donation
        </button>
        <button class="btn-add-another"
          onclick="addAndAnother('${club.Brand}','${club.Model}','${club.Type}',${value},'${ironSetInclude.value}',${document.getElementById('missing-clubs').checked})">
          + Add &amp; Donate Another
        </button>
      </div>
    `;
  });
}

function addToList(brand, model, type, value, ironSetOption, missingClubs) {
  donationClubs.push({ brand, model, type, value, ironSetOption, missingClubs });
  renderSelectedClubs();
  updateFormTextarea();
  updateStepProgress(3);
}

function addAndAnother(brand, model, type, value, ironSetOption, missingClubs) {
  donationClubs.push({ brand, model, type, value, ironSetOption, missingClubs });
  renderSelectedClubs();
  updateFormTextarea();
  resetFormForNew();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function removeClub(index) {
  donationClubs.splice(index, 1);
  renderSelectedClubs();
  updateFormTextarea();
  if (!donationClubs.length) resetSteps();
}

function renderSelectedClubs() {
  const el = document.getElementById('selectedClubs');
  if (!donationClubs.length) { el.style.display = 'none'; return; }

  let total = 0;
  const rows = donationClubs.map((c, i) => {
    total += c.value;
    const ironLabel = c.ironSetOption ? ` (${c.ironSetOption})` : '';
    return `
      <div class="selected-club-row">
        <div class="club-row-info">
          <span class="club-row-name">${c.brand} ${c.model} ${c.type}${ironLabel}</span>
          <span class="club-row-value">$${c.value.toFixed(2)} donation value</span>
        </div>
        <button class="btn-remove-club" onclick="removeClub(${i})">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M6 18L18 6M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>`;
  }).join('');

  el.style.display = 'block';
  el.innerHTML = `
    <div class="selected-clubs-title">
      Your Donation Queue
      <span class="club-count-badge">${donationClubs.length} club${donationClubs.length !== 1 ? 's' : ''}</span>
    </div>
    ${rows}
    <div class="selected-total-row">
      <span class="selected-total-label">Total Donation Value</span>
      <span class="selected-total-value">$${total.toFixed(2)}</span>
    </div>
    <div class="selected-actions">
      <button class="btn-proceed" onclick="proceedToForm()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        Continue to Donation Form
      </button>
      <button class="btn-start-over" onclick="startOver()">Start Over</button>
    </div>
  `;
}

function updateFormTextarea() {
  const list = donationClubs.map(c => {
    const iron = c.ironSetOption ? ` (${c.ironSetOption}${c.missingClubs ? ', Incomplete' : ''})` : '';
    return `${c.brand} ${c.model} ${c.type}${iron} – $${c.value.toFixed(2)} donation`;
  }).join(', ');
  const ta = document.querySelector('textarea[data-type="textarea"]');
  if (ta) ta.value = list;
}

function proceedToForm() {
  const s = document.getElementById('donateFormSection');
  s.style.display = 'block';
  s.scrollIntoView({ behavior: 'smooth' });
  updateFormTextarea();
}

function startOver() {
  donationClubs = [];
  renderSelectedClubs();
  resetFormForNew();
  document.getElementById('donation-result').style.display = 'none';
}

function resetFormForNew() {
  document.getElementById('donate-form').reset();
  document.getElementById('brand').innerHTML  = '<option value="">Select brand</option>';
  document.getElementById('model').innerHTML  = '<option value="">Select model</option>';
  document.getElementById('iron-set-include').value = '';
  document.getElementById('iron-set-options').style.display = 'none';
  document.getElementById('missing-clubs').checked = false;
  document.querySelector('input[name="condition"][value="average"]').checked = true;
  document.getElementById('donation-result').style.display = 'none';
  resetSteps();
  updateStepProgress(1);
}

function updateStepProgress(active) {
  for (let i = 1; i <= 3; i++) {
    const pill = document.getElementById(`step-pill-${i}`);
    const line = document.getElementById(`step-line-${i}`);
    if (pill) pill.classList.toggle('active', i <= active);
    if (line) line.classList.toggle('active', i < active);
  }
}

function resetSteps() { updateStepProgress(1); }

document.addEventListener('DOMContentLoaded', () => {
  const url = window.GOLF_CLUBS_URL;
  if (!url) {
    showMsg('Configuration error — please contact support.');
    return;
  }
  fetch(url)
    .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.text(); })
    .then(text => {
      const data = JSON.parse(text);
      if (Array.isArray(data)) loadData(data);
      else throw new Error('Data not an array');
    })
    .catch(() => showMsg('Unable to load club data. Please refresh and try again.'));
});

function showMsg(msg) {
  const el = document.getElementById('donation-result');
  if (el) {
    el.style.display = 'block';
    el.innerHTML = `<div class="msg-error">${msg}</div>`;
  }
}
